var WizardType = /* @__PURE__ */ ((WizardType2) => {
  WizardType2["MOVE_IN"] = "move-in";
  WizardType2["RESERVATION_WITH_FEE"] = "reservation-with-fee";
  return WizardType2;
})(WizardType || {});
export {
  WizardType
};
//# sourceMappingURL=Requests.mjs.map